import { signal } from "@preact/signals-react"

export const autoEuropeCheckersTableData = signal([])
export const autoEuropeCheckersTableIsLoading = signal(false)